export default "__VITE_ASSET__6459d9ce__"